import { NgModule } from '@angular/core';
import { TenantShellComponent } from './tenant-shell.component';

@NgModule({
  imports: [TenantShellComponent],
  exports: [TenantShellComponent]
})
export class TenantShellModule {}
